import styled from "@emotion/styled";

export const StyledMediaInfo = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "nowrap",
    overflow: "hidden",
    gap: theme.spacing(1),
    alignItems: "center",
    color: theme.kaltura.palette.tone2,
    ...theme.kaltura.typography.body2Highlight,
    alignSelf: "flex-start",
    marginTop: theme.spacing(2),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        marginTop: theme.spacing(1),
        flexGrow: 1,
    },
}));

export const StyledSeparator = styled("div")(({ theme }) => ({
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: theme.kaltura.palette.tone2,
    flexShrink: 0,
}));
